import { toast } from "sonner";
import axios from "../axios";
import { useContext, useState } from "react";
import { UserContext } from "../../components/context/UseContext";

export const useFAQ = () => {
  const { token } = useContext(UserContext);
  const [faq, setFaq] = useState();

  const [isLoading, setIsLoading] = useState(false);

  const getFaq = async () => {
    try {
      setIsLoading(true);
      const res = await axios.get("/audiences/faq", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      });
      if (res.status === 200) {
        setFaq(res.data.data);
        setIsLoading(false);
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.respose.data.message);
    }
  };

  const StoreFaq = async () => {
    try {
      const res = await axios.post(
        "/audiences/faq",
        JSON.stringify({
          question: "",
        }),
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        }
      );
      if (res.status === 201) {
        toast.success("Your question has been submitted successfully!");
      }
    } catch (err) {
      setIsLoading(false);
      toast.error(err.respose.data.message);
    }
  };

  return {
    getFaq,
    StoreFaq,
    faq,
    setFaq,
    isLoading,
  };
};
